function ApiError( response, statusCode, message, fileName, lineNumber ) {
	if ( !message ) {
		message = JSON.stringify( response );
	}
	var instance = new Error( message, fileName, lineNumber );
	instance.name = 'ApiError';
	instance.statusCode = statusCode;
	instance.response = response;
	Object.setPrototypeOf( instance, Object.getPrototypeOf( this ) );
	if ( Error.captureStackTrace ) {
		Error.captureStackTrace( instance, ApiError );
	}
	return instance;
}

ApiError.prototype = Object.create( Error.prototype, {
	constructor: {
		value: Error,
		enumerable: false,
		writable: true,
		configurable: true,
	},
} );

if ( Object.setPrototypeOf ) {
	Object.setPrototypeOf( ApiError, Error );
} else {
	ApiError.__proto__ = Error;
}

export default ApiError;
